export default "__VITE_ASSET__CZUbIvTt__"